document.addEventListener("DOMContentLoaded", function(event) { 

    const allAddAllButtons = document.querySelectorAll('.featured-collection__add-all button')
    for (const oneAddAllButton of allAddAllButtons) {
      oneAddAllButton.addEventListener('click', function handleClick() {
          const sectinID = oneAddAllButton.getAttribute('section-id')
          const firstProduct = document.querySelector('#CollectionSectionHidden-' + sectinID + ' .grid-product.grid-item:first-child .js-quick-add-btn')
          const allProductCards = document.querySelectorAll('#CollectionSection-' + sectinID + ' .featured-collection__main .grid-product__available.grid-item')
          let allProducts = []
          for (const oneCard of allProductCards) {
            const variantID = oneCard.getAttribute('data-variant-id')
            let oneProduct = {
                id: parseInt(variantID),
                quantity: 1
            }
            allProducts.push(oneProduct)
          }
          
          allProducts.shift(-1)

          $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: {items: allProducts},
            beforeSend: function () {
                console.log('Adding')
            },
            success: function (product) {
                console.log('Added')
                firstProduct.click()
            },
            error: function (XMLHttpRequest) {
                console.log('Error during adding')
            }
        });

      });
    }

    // Fix product slider viewport height to prevent reflow
    function fixProductSliderHeight() {
      const productSliders = document.querySelectorAll('.product-slideshow');
      productSliders.forEach(function(slider) {
        const viewport = slider.querySelector('.flickity-viewport');
        if (viewport) {
          // Get height from CSS or use default
          const computedStyle = window.getComputedStyle(slider.querySelector('.product-main-slide'));
          const slideHeight = computedStyle.height || '600px';
          viewport.style.height = slideHeight;
        }
      });
    }

    // Run on DOM ready
    fixProductSliderHeight();

    // Run after Flickity initializes (with a small delay)
    setTimeout(function() {
      fixProductSliderHeight();
    }, 100);

    // Run on window resize
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        fixProductSliderHeight();
      }, 250);
    });

    // Zoom desktop desabilitado conforme solicitado
    // function initProductImageZoom() {
    //   ... código comentado ...
    // }

    // initProductImageZoom();

    // Observers e event listeners do zoom também desabilitados
    // const productImagesContainer = document.querySelector('[data-product-images]');
    // if (productImagesContainer) {
    //   const observer = new MutationObserver(function(mutations) {
    //     initProductImageZoom();
    //   });
    //   observer.observe(productImagesContainer, {
    //     childList: true,
    //     subtree: true
    //   });
    // }

    // window.addEventListener('resize', function() {
    //   initProductImageZoom();
    // });

    // Descrição inicia aberta por padrão, mas permite fechar normalmente
    // O force_open: true no Liquid já faz ela iniciar aberta
    // Não precisamos de proteção adicional - o usuário pode fechar se quiser

    // Garantir que descrição fique aberta no mobile apenas quando is-open
    function ensureDescriptionOpenOnMobile() {
      const forceOpenAccordions = document.querySelectorAll('.collapsibles-wrapper.force-open .collapsible-content--all');
      
      forceOpenAccordions.forEach(function(accordion) {
        const isOpen = accordion.classList.contains('is-open');
        const inner = accordion.querySelector('.collapsible-content__inner');
        
        if (isOpen && inner) {
          // Quando aberto: calcular altura real e mostrar
          const originalHeight = accordion.style.height;
          accordion.style.height = 'auto';
          const realHeight = inner.offsetHeight;
          accordion.style.height = realHeight + 'px';
          
          // Garantir visibilidade
          accordion.style.visibility = 'visible';
          accordion.style.opacity = '1';
          accordion.style.overflow = 'visible';
          accordion.style.transform = 'translateY(0)';
        } else if (!isOpen) {
          // Quando fechado: garantir que fique escondido
          accordion.style.visibility = 'hidden';
          accordion.style.opacity = '0';
          accordion.style.height = '0';
          accordion.style.overflow = 'hidden';
          accordion.style.transform = 'translateY(-10px)';
        }
      });
    }

    // Observar mudanças no estado dos accordions
    function observeAccordionChanges() {
      const forceOpenWrappers = document.querySelectorAll('.collapsibles-wrapper.force-open');
      
      forceOpenWrappers.forEach(function(wrapper) {
        const accordion = wrapper.querySelector('.collapsible-content--all');
        const trigger = wrapper.querySelector('.collapsible-trigger');
        
        if (accordion && trigger) {
          // Observar mudanças na classe is-open
          const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                ensureDescriptionOpenOnMobile();
              }
            });
          });
          
          observer.observe(accordion, {
            attributes: true,
            attributeFilter: ['class']
          });
          
          observer.observe(trigger, {
            attributes: true,
            attributeFilter: ['class']
          });
          
          // Também observar cliques no trigger
          trigger.addEventListener('click', function() {
            setTimeout(ensureDescriptionOpenOnMobile, 100);
          });
        }
      });
    }

    // Executar quando DOM estiver pronto
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        ensureDescriptionOpenOnMobile();
        observeAccordionChanges();
      });
    } else {
      ensureDescriptionOpenOnMobile();
      observeAccordionChanges();
    }

    // Re-executar após um delay para garantir que o tema terminou de inicializar
    setTimeout(function() {
      ensureDescriptionOpenOnMobile();
      observeAccordionChanges();
    }, 500);
    
    setTimeout(function() {
      ensureDescriptionOpenOnMobile();
      observeAccordionChanges();
    }, 1000);

});
